import { render, staticRenderFns } from "./serviceProviderAdd.vue?vue&type=template&id=4208eada&scoped=true&"
import script from "./serviceProviderAdd.vue?vue&type=script&lang=js&"
export * from "./serviceProviderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4208eada",
  null
  
)

export default component.exports